export default __webpack_public_path__ + "static/media/surveyMonkey.fb5f9e7e.png";